import { GETFISCALREPORTDEAD, GETFISCALREPORTACT } from "./Constants";

export type PorfolioState =
{
    fiscalReportActivas: unknown[];
    fiscalReportCerradas: unknown[];
};

export const INITIAL_STATE: PorfolioState =
{
    fiscalReportActivas: [],
    fiscalReportCerradas: [],
};

type PorfolioAction =
{
    type: string;
    payload?: any;
};

export default function portfolioReducer(state: PorfolioState = INITIAL_STATE, action: PorfolioAction): PorfolioState
{
    switch(action.type)
    {
        case GETFISCALREPORTACT:
            return { ...state, fiscalReportActivas: action.payload };
        case GETFISCALREPORTDEAD:
            return { ...state, fiscalReportCerradas: action.payload };
        default:
            return state;
    }
}